export const INITIALIZE_LAENDER_STORE = 'laender.initializeLaenderStore';

export const SET_LAENDER = 'laender.setLaender';

export const SET_IS_LOADING = 'laender.setIsLoading';

export const SET_TIME_UPDATED = 'laender.setTimeUpdated';

import apiService from '@/core/common/services/api.service';
const moment = require('moment');

const state = () => ({
  laender: [],
  isLoading: false,
  timeUpdated: null,
});

const actions = {
  [INITIALIZE_LAENDER_STORE](context) {
    if (!context.state.timeUpdated || moment().diff(moment(context.state.timeUpdated), 'minutes') > 10) {
      context.commit(SET_TIME_UPDATED, moment());
      context.commit(SET_IS_LOADING, true);
      return apiService
        .get('Land')
        .then(response => {
          // Die Route liefert ein flaches Array unter result, kein OData-result.value
          context.commit(SET_LAENDER, response.data.result);
          context.commit(SET_IS_LOADING, false);
        })
        .catch(() => {
          context.commit(SET_IS_LOADING, false);
        });
    }
  },
};

const getters = {};

const mutations = {
  [SET_TIME_UPDATED](state, time) {
    state.timeUpdated = time;
  },
  [SET_LAENDER](state, laender) {
    state.laender = laender;
  },
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
